import React from "react";
import "./nickname.scss";

export default function RibbonFlag({ nick_name }) {
  return <div className="flag">{nick_name}</div>;
}
